import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import "./PlayerProfile.css";
import Reupload from "../ReuploadVideo/ReUpload";
import { BASE_URL } from "../../../api";
import { useNavigate } from "react-router-dom";

function StudentDetail() {
  const [student, setStudent] = useState({});
  const params = useParams();
  const navigate = useNavigate();

  // ______Student___preview_API_____________________________
  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${BASE_URL}students/detail/`, {
      method: "POST",
      body: JSON.stringify({
        id: params?.id,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Token ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setStudent(data?.data);
        // console.log(data); // log the fetched data
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, [params?.id]);

  // ___________Payment_Re-attempt_API__________________________
  const handleSubmit = () => {
    const token = localStorage.getItem("token");
    fetch(`${BASE_URL}students/detail/`, {
      method: "POST",
      headers: {
        "Content-type": "application/json; charset=UTF-8",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({
        id: params?.id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        // setStudent(data?.data);
        // console.log(data); // log the fetched data
        navigate(`/ease-buzz/${data.data?.id}`, { state: data.data });
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <div className="playerProfile">
      {/* ------------Payment-Button-Conditional-Rendering----------------------- */}
      {!student.is_paid ? (
        <div className="paymentPending-preview-profile">
          <h3>Your payment is pending to complete your enrollment pay now </h3>

          <button
            className="profile-preview-payment-btn"
            onClick={handleSubmit}
          >
            Pay now
          </button>
        </div>
      ) : (
        <></>
      )}

      {/* -------------------------------------- */}

      <div className="playerCard">
        <div className="playerVideo">
          <div>
            <video
              className="pre_player_video"
              src={student.video}
              autoPlay
              loop
              muted
              controls
            />
          </div>
          {/* --------------Re-upload-Conditional-render---------------------- */}
          {!student.is_reupload ? <Reupload /> : <></>}

          {/* -------------------------------------- */}
        </div>
        <div className="pre-main-ply-pro">
          <div className="pre-img-data-col-1">
            <div className="pre-per-img">
              <img src={student.photo} alt="" />
            </div>
            <div className="data-personal-prew">
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> FULL NAME</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.full_name}</h2>
                </div>
              </div>
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> DATE OF BIRTH</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.date_of_birth}</h2>
                </div>
              </div>
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> MOBILE NUMBER</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.mobile}</h2>
                </div>
              </div>
            </div>
          </div>

          {/* --------------------------------------------- */}

          <div className="pre-personal-data-col-2">
            <div className="pre_player_profile-col2_col_1">
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> EMAIL</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.email}</h2>
                </div>
              </div>
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> SCHOOL NAME</h3>
                </div>

                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.school_name}</h2>
                </div>
              </div>

              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> STATE</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.state}</h2>
                </div>
              </div>
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> DISTRICT</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.district}</h2>
                </div>
              </div>
            </div>
            {/* -------------- */}
            <div className="pre_player_profile-col2_col_2">
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3>ADDRESS</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.address}</h2>
                </div>
              </div>
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3> PLAYING ROLE</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.playing_role}</h2>
                </div>
              </div>
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3>BATTING STYLE</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.batting_style}</h2>
                </div>
              </div>
              <div className="Fullname_pre">
                <div className="pre-filed-static">
                  <h3>BOWLING STYLE</h3>
                </div>
                <div className="pre-field-dynamic">
                  <h2>:</h2>&nbsp;&nbsp;<h2>{student.bowling_style}</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StudentDetail;
